/**
 *
 * Modal
 *
 */

import React from 'react';
import PropTypes from 'prop-types';

import Portal from 'components/Portal';

import ModalContainerWrapper from './styles/ModalContainerWrapper';
import ModalBackground from './styles/ModalBackground';
import ModalWrapper from './styles/ModalWrapper';

const Modal = React.memo(function Modal(props) {
  const {
    backdropColor,
    children,
    isOpen,
    maxWidth,
    width,
  } = props;

  if (!isOpen) return null;

  return (
    <Portal>
      <ModalContainerWrapper>
        <ModalBackground
          backdropColor={backdropColor}
        />
        <ModalWrapper maxWidth={maxWidth} width={width}>
          {children}
        </ModalWrapper>
      </ModalContainerWrapper>
    </Portal>
  );
});

const propTypes = {
  backdropColor: PropTypes.string,
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  maxWidth: PropTypes.string,
  width: PropTypes.string,
  
};
const defaultProps = {
  backdropColor: 'rgba(39, 39, 39, 1)'
};

Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;
export default Modal;
